import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { AccessCodeVerificationDialogProps } from "./types";

export const AccessCodeVerificationDialog = ({
  isOpen,
  onClose,
  onVerify,
  expectedCode,
}: AccessCodeVerificationDialogProps) => {
  const [accessCode, setAccessCode] = useState("");

  const handleVerify = async () => {
    if (accessCode === expectedCode) {
      // Update last_verified_at in the database
      const { error } = await supabase
        .from("access_controls")
        .update({ 
          last_verified_at: new Date().toISOString() 
        })
        .eq("access_code", expectedCode);

      if (error) {
        console.error("Error updating verification time:", error);
        toast.error("Une erreur est survenue lors de la vérification");
        return;
      }

      onVerify();
      onClose();
      setAccessCode("");
    } else {
      toast.error("Code d'accès incorrect");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Vérification du code d'accès</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <Input
            type="text"
            placeholder="Entrez le code d'accès"
            value={accessCode}
            onChange={(e) => setAccessCode(e.target.value)}
          />
          <Button onClick={handleVerify} className="w-full">
            Vérifier
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};